import { makeStyles } from '@material-ui/core/styles';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(() => ({
  headerText: {
    height: '2.4vh',
    fontWeight: 500,
    fontSize: 20,
    display: 'flex',
    alignItems: 'center',
    minHeight: '33px',
  },
  titleContainer: {
    marginTop: '3.51vh',
  },
  titleText: {
    whiteSpace: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
  },
  priceText: {
    height: '2.4vh',
    fontWeight: 500,
    fontSize: 20,
    textAlign: 'right',
    letterSpacing: '0.0025em',
    minHeight: '33px',
    lineHeight: '35px',
  },
  promotion: {
    margin: '2% 2%',
  },
  returnIcon: {
    marginLeft: '10px',
    height: '32px',
    width: '32px',
    marginTop: '2%',
    marginBottom: '2%',
  },
  promotionRow: {
    marginTop: '1%',
  },
  savings: {
    textAlign: 'right',
  },
  taxExemptionRow: {
    marginTop: '1%',
  },
  itemFeeRow: {
    marginTop: '1%',
    marginLeft: '-32px',
    width: 'calc(100% + 32px)',
    fontSize: 18,
  },
  codeText: {
    height: '2.4vh',
    color: themeColor.subheaderLight,
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 20,
    display: 'flex',
    alignItems: 'center',
    letterSpacing: '0.0025em',
    marginTop: '0.73vh',
  },
  gridSpace: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  alignRight: {
    textAlign: 'right',
  },
  alignLeft: {
    textAlign: 'left',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '0.732vw',
  },
  row: {
    height: '50%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  tenderText: {
    fontStyle: 'normal',
    fontFamily: 'Roboto',
    alignSelf: 'flex-end',
    fontSize: '1.5rem',
  },
  tenderContainer: {
    flexDirection: 'column',
    flexWrap: 'nowrap',
    textAlign: 'center',
    height: '100%',
    width: '100%',
  },
  returnText: {
    fontStyle: 'normal',
    fontFamily: 'Roboto',
    fontSize: '1.5rem',
    flex: '1',
  },
  returnShadowText: {
    fontStyle: 'normal',
    color: themeColor.subheaderLight,
    fontFamily: 'Roboto',
    fontSize: '1.25rem',
    flex: '1',
  },
  returnContainer: {
    marginTop: '3.51vh',
    display: 'flex',
    flexDirection: 'column',
  },
  returnRow: {
    alignItems: 'center',
    height: '36px',
    marginBottom: '3.125vh',
    display: 'flex',
    flexWrap: 'unset',
  },
  iconSpacing: {
    flex: '0 0 3.9531vw',
    marginRight: '0.732vw',
  },
  returnlinkedItemRow: {
    marginTop: '-2.5vh',
    marginLeft: '3vw',
  },
  itemDescFlexBox: {
    flex: '0 0 32px',
  },
  linkedItemContainer: {
    marginTop: '2.0833vh',
  },
  validateWeightContainer: {
    marginTop: '1.562vh',
  },
  advertText: {
    flexGrow: 1,
  },
  topReturnFlexBox: {
    flex: 5,
  },
}));
